class GridViewToggle extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'collection-grid-view';
    this.buttons = Array.from(this.querySelectorAll('.grid-view-toggle__button'));
    this.grid = document.getElementById('product-grid');

    if (this.grid) {
      this.standardColumns = parseInt(this.grid.dataset.columnsDesktop, 10) || 4;
      this.denseColumns = Math.min(this.standardColumns + 1, 6);
    }
  }

  connectedCallback() {
    const storedView = window.localStorage.getItem(this.storageKey);
    if (storedView) {
      this.setView(storedView, false);
    }

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setView(button.dataset.view, true));
    });
  }

  setView(view, persist) {
    if (!this.grid) return;

    this.grid.classList.remove(
      `grid--${this.standardColumns}-col-desktop`,
      `grid--${this.denseColumns}-col-desktop`
    );
    this.grid.classList.add(
      `grid--${view === 'dense' ? this.denseColumns : this.standardColumns}-col-desktop`
    );

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.view === view ? 'true' : 'false');
    });

    if (persist) {
      window.localStorage.setItem(this.storageKey, view);
    }
  }
}

customElements.define('grid-view-toggle', GridViewToggle);
